import React from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link, Typography, makeStyles } from '@material-ui/core'
import Avatars from 'app/componentV4/Avatar/Avatars'

const useStyles = makeStyles({
  avatar: {
    width: '20px',
    height: '20px',
    fontSize: '10px',
    fontWeight: 'bold',
  },
})

const DisplaySubscriber = (props) => {
  const { data, onClick } = props

  const classes = useStyles()

  const firstSubscriber = data[0]
  const subscriberCount = data.slice(1)

  return (
    <>
      <Link
        className="text-neutrals-600 cursor-pointer hover:no-underline"
        onClick={onClick}
      >
        <div className="flex space-x-2">
          <Avatars
            id={firstSubscriber.id}
            name={`${firstSubscriber.firstName} ${firstSubscriber.lastName}`}
            src={firstSubscriber.profilePicture}
            characters={firstSubscriber.avatarCharacters}
            className={classes.avatar}
          />
          <Typography className="text-12 text-grey-400">
            {firstSubscriber.firstName}
          </Typography>
          {R.length(subscriberCount) > 0 ? (
            <Typography className="text-12 text-grey-400">
              <FormattedMessage
                id="metrics.other"
                values={{
                  count: R.length(subscriberCount),
                  u: (text) => (
                    <b>
                      <u>{text}</u>
                    </b>
                  ),
                }}
              />
            </Typography>
          ) : null}
        </div>
      </Link>
    </>
  )
}

const valuePropTypes = {
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profilePicture: PropTypes.string,
  avatarCharacters: PropTypes.string,
  lastSeen: PropTypes.string,
}
DisplaySubscriber.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(valuePropTypes)).isRequired,
  onClick: PropTypes.func.isRequired,
}

export default DisplaySubscriber
